import StandMarker from './layers/StandMarker';
export default class StandLayer {
    constructor(props) {
        this.addToMap = (map) => {
            var _a;
            if (this._map)
                return;
            this._map = map;
            (_a = this._marker) === null || _a === void 0 ? void 0 : _a.addToMap(this._map);
        };
        this.removeFromMap = () => {
            var _a;
            if (!this._map)
                return;
            (_a = this._marker) === null || _a === void 0 ? void 0 : _a.removeFromMap();
            this._map = undefined;
        };
        this.stand = props.stand;
        if (!props.stand.disabled)
            this._marker = new StandMarker(props);
    }
}
